import { FiTrash2, FiStar } from "react-icons/fi";
import { FaStar } from "react-icons/fa";
import shareLight from "../../../../../assets/shareLight.svg";
import shareDark from "../../../../../assets/shareDark.svg";
import editLight from "../../../../../assets/editLight.svg";
import editDark from "../../../../../assets/editDark.svg";
import React from "react";
import {useAppStore} from "../../../../../GlobalStore/GlobalStore.ts";
import {shareClick} from "../../../../../Utils/db/sharedChats/shareChatClick.ts";

interface OptionsItemsProps {
    handleDeleteClick: (event: React.MouseEvent) => void;
    handleEditClick: (event: React.MouseEvent, chatId: string) => void;
    handleFavoriteClick: (event: React.MouseEvent, chatId: string) => void;
    chatId: string;
}

const OptionsItems: React.FC<OptionsItemsProps> = ({ handleDeleteClick, handleEditClick, handleFavoriteClick, chatId }) => {
    const settingsObj = useAppStore((state: any) => state.settingsObj);
    const { theme } = settingsObj;
    const userObj = useAppStore((state: any) => state.userObj);
    const setDynamicStateObj = useAppStore((state: any) => state.setDynamicStateObj);
    const dynamicStateObj = useAppStore((state: any) => state.dynamicStateObj);
    const { chatHistory } = dynamicStateObj;

    // Find current chat to check if it's favorited
    const currentChat = chatHistory.find((chat: any) => chat.id === chatId);
    const isFavorited = currentChat?.isFavorite || false;

    const handleShareClick = async (event: React.MouseEvent) => {
        event.stopPropagation();
        setDynamicStateObj({isMenuOpen: false});

        shareClick(setDynamicStateObj, chatHistory, chatId, userObj.user);
    }

    const favoriteOption = {
        icon: isFavorited ? <FaStar className={"h-4 w-4 text-yellow-500"} /> : <FiStar className={"h-4 w-4"} />,
        label: isFavorited ? "Unfavorite" : "Favorite",
        onClick: (event: any) => handleFavoriteClick(event, chatId)
    };

    const baseOptions = [
        { icon: <img className={"h-4 w-4"} src={`${theme === "dark" ? editLight : editDark}`} alt="Edit chat" />, label: "Rename", onClick: (event: any) => handleEditClick(event, chatId) },
        { icon: <FiTrash2 className={"h-4 w-4"} />, label: "Delete", color: "text-red-500", onClick: handleDeleteClick }
    ];

    const shareOption = {
        icon: <img className={"h-4 w-4"} src={`${theme === "dark" ? shareLight : shareDark}`} alt="Share chat" />,
        label: "Share",
        onClick: (event: any) => handleShareClick(event)
    };

    const OptionsItems = [shareOption, favoriteOption, ...baseOptions];

    return (
        <div>
            {OptionsItems.map((item, i) => (
                <button
                    key={i}
                    onClick={item.onClick}
                    className={`w-full text-left px-4 py-2 text-sm ${item.label === "Delete" ? "text-red-500" : "text-neutral-700 dark:text-neutral-200"} hover:bg-neutral-200 dark:hover:bg-neutral-700 flex items-center`}
                    aria-label={item.label}
                >
                    <span className={`mr-2 ${item.label === "Delete" ? "text-red-500" : ""}`}>{item.icon}</span>
                    {item.label}
                </button>
            ))}
        </div>
    );
};

export default OptionsItems;